// this file is generated by update_shopify_store_data.py at 2026-03-18 20:30:13.109709
var courses = [
    {
        "course_id": "4F2834D5-F351-F011-999A-005056A7F31D",
        "course_version": 2,
        "name": "Essentials of Neonatal Critical Care Orientation",
        "course_type": 32,
        "author_information": "",
        "description": "Developed in collaboration with their Neonatal Advisory Committee and subject matter experts, Pediatric Learning Solutions: Essentials of Neonatal Critical Care Orientation (ENCCO) uniquely bridges the knowledge gap between what clinicians learn in school and what is expected of them in treating their tiny, critically ill patients. These CE-approved courses ensure all orientees receive evidence-based, standardized education with content that is continually reviewed and updated.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "DCC894E9-2E51-F011-9998-005056A730AF",
                "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "835A74CB-4B74-E311-8219-0015171350B2",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Neonatal Nutrition Overview",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Infants admitted to the NICU are at risk for secondary nutrition associated comorbidities. They often experience clinical setbacks that prevent the achievement of adequate nutrition. Preterm infants are at even greater risk related to deficits in nutrient stores, inflammation, dysbiosis, immature organ systems(such as brain, respiratory, renal and gastrointestinal)and high demands for maturation and growth. \r\n\r\nThis course discusses current evidence-based nutrition practices related to the hospitalized newborn.  \r\n\r\nAttribution: Courtesy of International Biomedical, Ltd.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Identify the goals of nutritional support for the premature or high-risk infant.</li>\r\n    <li>Distinguish newborn classifications by gestational age and outline components of nutrition screening and assessment.&nbsp;</li>\r\n    <li>Analyze nutritional requirements, challenges and associated comorbidities for premature and high-risk infants with congenital anomalies or medical conditions.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "335B74CB-4B74-E311-8219-0015171350B2",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Neonatal Pain Assessment and Management",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Hospitalized neonates and infants often experience pain. Assessing and managing their pain effectively through pharmacologic and non-pharmacologic means is a part of comprehensive neonatal care.\r\n\r\nWhat will you learn in this course?\r\n\r\nThis course addresses the assessment and management of neonatal and infant pain. Specifically:\r\nIndicators of pain in the neonate and infant\r\nPain assessment scales used to evaluate pain \r\nPharmacological and non-pharmacological management of pain in this population\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Describe neonatal and infant behavioral and physiological responses to pain.&nbsp;</li>\r\n    <li>Explain considerations for selecting a pain assessment tool for use with neonates and infants.&nbsp;</li>\r\n    <li>Outline non-pharmacologic pain management interventions and pharmacologic pain management for the neonate and infant.&nbsp;</li>\r\n    <li>Identify interventions for managing procedural pain in the neonate and infant.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "455879C5-4B74-E311-8219-0015171350B2",
                "course_version": 5,
                "name": "PLS - ENCCO: Respiratory Care: Meconium Aspiration Syndrome",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Meconium aspiration syndrome (MAS) is a clinical condition characterized by respiratory distress in infants born through meconium-stained amniotic fluid. Providing effective care to these infants requires the ability to accurately assess an infant in distress and rapidly initiate an appropriate intervention to correct the underlying cause of distress. What will you learn in this course?\r\n\r\nThis course introduces meconium aspiration syndrome including:\r\nPathophysiology\r\nRisk factors\r\nAssessment parameters\r\nCurrent treatment modalities\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Explain the pathophysiology of meconium aspiration syndrome(MAS), including the mechanical and chemical mechanisms that occur.</li>\r\n    <li>Identify maternal and infant risk factors for the development of MAS.</li>\r\n    <li>Describe the clinical presentation including diagnostic radiographic findings of MAS.</li>\r\n    <li>Outline current interventions used in the prevention and management of MAS.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "7CA669C4-4B74-E311-9299-001517135400",
                "course_version": 5,
                "name": "PLS - ENCCO: Metabolic Function and Disorders: Hyperbilirubinemia",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Indirect bilirubin elevation is a normal physiologic finding in newborn infants, regardless of gestational age. Approximately 60 to 80% of full-term newborns will exhibit jaundice, though only a small proportion will require treatment. Rapidly rising bilirubin levels, or hyperbilirubinemia, accompanied by neurological symptoms are considered dangerous and warrants prompt evaluation and intervention to prevent permanent neurologic injury.\r\n\r\nThis course will explore the physiology of neonatal hyperbilirubinemia and its various etiologies, along with current approaches to monitoring, evaluating and treating hyperbilirubinemia in the newborn.    \r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Explain physiologic and clinical risk factors contributing to newborn hyperbilirubinemia.</li>\r\n    <li>Discuss the links between hyperbilirubinemia and breastfeeding.</li>\r\n    <li>Compare and contrast physiologic and pathologic hyperbilirubinemia.</li>\r\n    <li>Identify diagnostic testing for hyperbilirubinemia and summarize two primary treatment methods, including their complications.</li>\r\n    <li>Differentiate acute bilirubin encephalopathy and bilirubin-induced neurological dysfunction.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "ED3EECCA-4B74-E311-9299-001517135400",
                "course_version": 5,
                "name": "PLS - ENCCO: Neurology: Neonatal Cranial Hemorrhage",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course will discuss cranial hemorrhages common in the neonatal period of both the preterm and term infant. The pathophysiology, diagnostic features and grading criteria of intraventricular, extracranial and intracranial hemorrhages will be described. Periventricular leukomalacia (PVL) will also be discussed including its connection with cerebral palsy.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Outline vascular, extravascular and intravascular factors associated with the development of intraventricular hemorrhage (IVH).&nbsp;</li>\r\n    <li>Discuss the presentation, diagnosis, and criteria associated with grading IVH.&nbsp;</li>\r\n    <li>Outline interventions and care strategies for the preterm infant with IVH.&nbsp;</li>\r\n    <li>Describe the presentation, prognosis and strategies for prevention of white matter injury, including periventricular leukomalacia (PVL).&nbsp;</li>\r\n    <li>Recognize the cranial hemorrhages associated with the term infant and diagnostic methods available to identify a hemorrhage.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "AD064929-8D73-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Respiratory Care: Bronchopulmonary Dysplasia",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Infants who are born prematurely or who experience respiratory problems soon after being born are at risk for developing bronchopulmonary dysplasia(BPD). BPD, also called chronic lung disease(CLD), can be a serious condition requiring intensive medical intervention. This course discusses the pathophysiology, risk factors, clinical presentation, diagnosis and interventions related to BPD.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Explain the pathophysiology including the pathways of injury and related risk factors for development of bronchopulmonary dysplasia(BPD).&nbsp;</li>\r\n    <li>Discuss interventions to reduce the risk of BPD.&nbsp;</li>\r\n    <li>Describe the clinical presentation and related diagnosis of BPD.&nbsp;</li>\r\n    <li>Outline the current treatment modalities for an infant with BPD.&nbsp;</li>\r\n    <li>Summarize the related outcomes and potential complications of BPD.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C7E2C018-5174-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Extrauterine Life: Fetal to Neonatal Circulation",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "While in utero, important anatomical structures help facilitate an optimal environment for the fetus to grow and develop. Upon birth, several key changes occur immediately that are vital to the successful transition from fetal to neonatal circulation. What will you learn in this course?\r\n\r\nThis course introduces:\r\nBasic fetal development\r\nKey functions of the placental and fetal shunts\r\nExpected changes in the newborn\u2019s circulatory system after birth\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Recognize key stages in the normal development of the cardiovascular system in the fetus.&nbsp;</li>\r\n    <li>Recall primary features of normal fetal circulation including anatomical structures/shunts and blood flow.&nbsp;</li>\r\n    <li>Identify changes to blood flow pathways and anatomical structures during the neonate&rsquo;s transition to extrauterine life.&nbsp;</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D9CDC01A-6874-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Neonatal Pharmacokinetics",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Pharmacokinetics (PK) is the study of the passage of drugs into the body, through it, and out of the body. In other words, pharmacokinetics examines how the body metabolizes and processes drugs throughout the body. The four main parameters of how drugs move through the body are: absorption, distribution, metabolism and excretion. The PK of drugs differ in the neonatal population from that of older infants, children and adults. Understanding these differences is essential for the safe administration of medications in neonates.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Define key terminology and concepts related to fetal and neonatal development.</li>\r\n    <li>Explain developmental differences that influence pharmacokinetics parameters in neonates.</li>\r\n    <li>Apply pharmacokinetic principles(absorption, distribution, metabolism, excretion)to specific medications used in the neonatal population.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "21E36899-9773-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Comprehensive Assessment of the Neonate",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "A clinician must be able to expertly perform initial, comprehensive neonatal assessments. The first opportunity to document well-being or identify abnormalities, this exam can mean the difference between life and death for a neonate.\r\n\r\nThis course discusses three key elements of neonatal assessment:\r\nMaternal, family and prenatal history\r\nGestational age assessment\r\nPhysical examination\r\n    \r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Describe the components of a maternal/family/prenatal history.</li>\r\n    <li>Classify a newborn by gestational age and weight.</li>\r\n    <li>Identify neonatal risk factors based on intrauterine growth patterns and the gestational age assessment.</li>\r\n    <li>List the steps to perform a neonatal head-to-toe physical assessment, utilizing four techniques of physical assessment.</li>\r\n    <li>Discuss normal versus abnormal findings of a neonatal physical exam.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "BA2D73C6-9773-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Extrauterine Life: Assessment of the Neonate's Transition",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Many physiological changes occur within the first few hours after birth, marking the newborn\u2019s transition to life outside the womb. During this critical period, the clinician must be able to recognize and manage these changes to ensure the infant adapts successfully to extrauterine life. \r\n\r\nThe clinician should:\r\nComplete an initial head-to-toe assessment\r\nIdentify at-risk neonates\r\nRecognize indications that the neonate is not transitioning successfully\r\n\r\nThis course will provide an overview of the components of transition to extrauterine life.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Recognize normal assessment characteristics, including cardiopulmonary changes, of the neonate in transition to extrauterine life.&nbsp;</li>\r\n    <li>Identify the signs that indicate the neonate is having difficulty transitioning to extrauterine life.&nbsp;</li>\r\n    <li>Summarize the characteristics of the high-risk or at-risk infant.&nbsp;</li>\r\n    <li>Explain the benefits of the Golden Hour and its impact on neonatal transition.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0CCF573A-6874-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Respiratory Care: Neonatal Respiratory Distress Syndrome",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Respiratory distress syndrome(RDS)is the most common respiratory disorder in premature and late preterm infants. It occurs due to a deficiency in surfactant, which plays a critical role in keeping small air sacs in the lung open to promote optimal gas exchange.\r\n\r\nThis course discusses the pathophysiology, risk factors, clinical presentation and complications of RDS. Current treatment and management strategies for infants with RDS are also discussed.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Describe the pathophysiology of respiratory distress syndrome(RDS).&nbsp;</li>\r\n    <li>Recognize the clinical presentation of RDS.&nbsp;</li>\r\n    <li>Outline current treatment and management strategies for RDS.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C52A9C78-6874-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Neonatal Skin Care",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The hospital setting can be harsh on a newborn\u2019s delicate skin, making proper skin care and prevention of skin damage essential in the neonatal population.\r\n\r\nThis course explores the structure and function of newborn skin, techniques for skin assessment and care, the safe application of barrier and adhesive products, and recommendations for addressing skin-related situations.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Describe the unique characteristics of skin maturation of premature and term infants.&nbsp;</li>\r\n    <li>Identify the goals and interventions of neonatal skin care.&nbsp;</li>\r\n    <li>Explain the differences and proper usage of barriers and adhesives used in neonatal skin care.&nbsp;</li>\r\n    <li>Outline the evidence-based practice guidelines for management of diaper dermatitis and IV infiltrates.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D59EC0F-E5F9-E611-AF66-005056B104B1",
                        "course_category_name": "Infant Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C37A5AAC-9773-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Developmental Care of the Newborn",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "After achieving autonomic stability of the cardiac and respiratory systems, the newborn\u2019s primary task upon birth is self-regulation. Adapting to the environment is a function of the central nervous system (CNS), and maturation of the CNS is imperative for self-regulation and successful adaptation to environmental stimuli. The clinician can help promote balance and encourage growth and development by recognizing and responding to the infant\u2019s behavior cues. In addition, family involvement promotes positive effects on the physical, cognitive and psychosocial development of all infants.\r\n\r\nWhat you will learn in this course:\r\nThis course will discuss the various subsystems of central nervous system development and review developmental care and neuroprotective strategies to promote stability and growth in the newborn.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Describe developmental differences in behaviors of the newborn based on gestational age.&nbsp;</li>\r\n    <li>Recall and describe the subsystems of the newborn's central nervous system(CNS)development.&nbsp;</li>\r\n    <li>Identify indicators of infant stress and stability for each subsystem.</li>\r\n    <li>Discuss interventions to reduce stress and promote stable behaviors.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FE6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physical Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Occupational Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC; Behavioral Health",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "CE"
                },
                "sub_courses": []
            },
            {
                "course_id": "53460F37-5174-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Family-Centered Care In the NICU",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The admission of a newborn to the NICU is a traumatic event for the entire family. All members of the health care team can help families cope by recognizing common stressors and employing evidence-based interventions.\r\n\r\nThis course discusses the core principles of providing family-centered care to the critically ill newborn and family, including key assessments and appropriate interventions for the family in crisis.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Define family-centered care and explain the core principles.</li>\r\n    <li>Discuss the major sources of stress for families of critically ill infants.</li>\r\n    <li>Discuss the role of social workers in supporting families in the NICU.</li>\r\n    <li>Describe evidence-based interventions to support families in crisis.</li>\r\n    <li>Identify appropriate Safe to Sleep&reg; behaviors to educate families.</li>\r\n    <li>Select appropriate strategies to facilitate a positive sibling visit.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC; Behavioral Health",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "CE"
                },
                "sub_courses": []
            },
            {
                "course_id": "1A3AA750-5174-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Metabolic Function and Disorders: Glucose Homeostasis In the Neonate",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Glucose homeostasis is the balance between how much glucose the body makes and how much it uses. For newborns, this balance is especially important because glucose is the primary fuel for the brain.\r\n\r\nAt birth, babies transition from getting a constant supply of glucose through the placenta to managing their own glucose levels. This change can be challenging, and some babies may need help keeping their blood sugar in a safe range. \r\n\r\nWhat will you learn in this course?\r\nHow glucose regulation works in newborns\r\nWhy some babies are more at risk for low or high blood sugar\r\nWhat nurses can do to support safe glucose levels in the first days of life\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Explain the mechanisms of glucose homeostasis in the fetus and neonate.</li>\r\n    <li>Identify risk factors for neonatal hypoglycemia and hyperglycemia.</li>\r\n    <li>Recognize clinical signs of glucose instability in term and preterm infants.</li>\r\n    <li>Apply current screening, monitoring, and treatment guidelines for managing neonatal hypoglycemia and hyperglycemia.</li>\r\n    <li>Describe potential short- and long-term outcomes associated with glucose dysregulation in newborns.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "63C8FCC7-6874-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Patient Care: Thermoregulation of the Newborn Infant",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides the clinician with the knowledge to provide the newborn a neutral thermal environment that will reduce the risks of cold stress and hyperthermia. Additionally, management strategies for these conditions will be presented.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<br />\r\n<ul>\r\n    <li>Summarize the physiology of temperature regulation in the newborn.&nbsp;</li>\r\n    <li>Differentiate the mechanisms of heat transfer and interventions to prevent heat loss.&nbsp;</li>\r\n    <li>Compare and contrast risk factors related to cold stress and potential management strategies.&nbsp;</li>\r\n    <li>Identify the signs of cold stress and hyperthermia.&nbsp;</li>\r\n    <li>Describe appropriate interventions to provide a neutral thermal environment for the newborn infant.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D59EC0F-E5F9-E611-AF66-005056B104B1",
                        "course_category_name": "Infant Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "5583D6E2-6874-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Respiratory Care: Transient Tachypnea of the Newborn",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Transient tachypnea of the newborn(TTN)is a common respiratory condition seen in the immediate newborn period. Characterized by delayed clearance of fetal lung fluid at the alveolar level, TTN is most commonly seen in late preterm and term infants. This course discusses the pathophysiology, risk factors, presentation, diagnosis and management of TTN.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Explain the pathophysiology of transient tachypnea of the newborn(TTN).</li>\r\n    <li>Recognize factors placing infants at risk for TTN.</li>\r\n    <li>Recognize TTN using standard clinical indicators.</li>\r\n    <li>Outline current standards of practice for managing TTN.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D59EC0F-E5F9-E611-AF66-005056B104B1",
                        "course_category_name": "Infant Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "1994B794-6874-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Metabolic Function and Disorders: Metabolic Disorders of the Newborn",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Metabolic disorders of the newborn can result in significant neonatal morbidity and mortality, but early identification and intervention can improve outcomes.\r\n\r\nThis course discusses the initial presentation, etiology, complications, and management typically seen with metabolic disorders, as well as the role of newborn screening in detection.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<br />\r\n<ul>\r\n    <li>Describe the five categories of metabolic disorders identified in the neonatal period, including the initial presentation.&nbsp;</li>\r\n    <li>Discuss the role of newborn screening for early identification of metabolic disorders.&nbsp;</li>\r\n    <li>Recall the presentation of metabolic disorders in the newborn including findings from the infant and family history, physical assessment, any abnormal odors and laboratory results.&nbsp;</li>\r\n    <li>Identify specific treatment and management strategies for metabolic disorders.&nbsp;</li>\r\n    <li>Explain the necessity of providing caregiver support and counseling after a positive finding on a newborn screen or diagnosis of a metabolic disorder.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "00A49AD2-9773-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Neonatal Vascular Access: Central Lines in the Neonate",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Central venous catheters (CVCs) are an essential access device for patients in the Neonatal Intensive Care Unit (NICU). Early CVC placement preserves vessels and reduces the number of venipuncture attempts. CVCs are commonly inserted in neonates for:   \r\nInfusion of medications and solutions that could damage peripheral veins\r\nBlood pressure monitoring\r\nBlood sampling\r\n\r\nThis course discusses the types of CVCs commonly used in the neonate, device selection and insertion, care and maintenance, ongoing assessment, and prevention and management of complications.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Explain why central venous catheters (CVCs) are necessary for patients in the NICU.&nbsp;</li>\r\n    <li>Identify types of CVCs used in the neonatal population.&nbsp;</li>\r\n    <li>Apply the steps of the insertion and maintenance bundles.&nbsp;</li>\r\n    <li>Recognize complications associated with CVCs.&nbsp;</li>\r\n    <li>Follow evidence-based measures to prevent and manage central line-associated complications.&nbsp;</li>\r\n    <li>Identify strategies to safely support neurodevelopmental care practices in neonates with central venous catheters.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "007AF458-6874-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Neurology: Neonatal Seizures",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The onset of seizure activity in the newborn requires immediate assessment and intervention by neonatal clinicians. Identifying the type of seizure activity and the underlying cause is crucial in management of neonatal seizures. This course will provide key information to promote your understanding of neonatal seizures and evidence-based, seizure-related care for the neonate and family.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<br />\r\n<ul>\r\n    <li>Explain the underlying etiologies for neonatal seizures.&nbsp;</li>\r\n    <li>Recognize abnormal newborn movements associated with seizures.&nbsp;</li>\r\n    <li>Differentiate the various seizure characteristics that might be observed in neonates.&nbsp;</li>\r\n    <li>Describe diagnostic tools used in the assessment of a newborn with suspected or confirmed seizures.&nbsp;</li>\r\n    <li>Evaluate the goals of clinical management for a neonate with suspected seizures.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C54D29AE-6874-E311-BC09-001517135511",
                "course_version": 5,
                "name": "PLS - ENCCO: Respiratory Care: Pneumothorax in the Neonate",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Pneumothorax is an abnormal accumulation of air into extra-alveolar spaces where air is not normally present. It is the most common pulmonary air leak that occurs in the neonatal period, occurring in a small number of term neonates and slightly more often in premature neonates. Neonatal pneumothorax can be associated with a varied range of clinical presentations from asymptomatic requiring no intervention to significant respiratory distress and systemic compromise requiring emergent treatment. Providing appropriate, evidence-based care to these patients requires the ability to rapidly assess, diagnose, and immediately intervene when necessary.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<br />\r\n<ul>\r\n    <li>Recognize the conditions that place an infant at risk for pneumothorax.</li>\r\n    <li>Explain the pathophysiology of a pneumothorax in the neonate.</li>\r\n    <li>Recognize clinical presentation of a pneumothorax in the neonate.</li>\r\n    <li>Outline current standards of practice for interventions and management of a pneumothorax in the neonate.</li>\r\n</ul>\r\n<br />",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D59EC0F-E5F9-E611-AF66-005056B104B1",
                        "course_category_name": "Infant Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E3D69666-7F71-E311-8226-0015171C5BB3",
                "course_version": 5,
                "name": "PLS - ENCCO: Respiratory Care: Apnea of Prematurity",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Apnea of prematurity(AOP)is a common respiratory occurrence observed in premature infants. Though readily corrected by appropriate clinical interventions, persistent episodes of apnea contribute to prolonged hospitalization and the need for home monitoring.\r\n\r\nWhile there are other reasons for apnea in the preterm infant, the focus of this course is on AOP. The course will discuss the pathophysiology, assessment, documentation and current standards of practice for managing apnea of prematurity.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Define apnea of prematurity(AOP)and differentiate from periodic breathing.&nbsp;</li>\r\n    <li>Describe the three types of apnea.&nbsp;</li>\r\n    <li>Identify common contributing factors to AOP.&nbsp;</li>\r\n    <li>Outline current standards of practice for managing AOP.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "58382785-93D1-E511-BF53-005056B122EA",
                        "course_category_name": "Respiratory Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ANCC",
                    "credit_units": 0.08,
                    "credit_unit_display_name": "CRCE; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E26B13A4-5BBA-F011-99A0-005056A78EAA",
                "course_version": 1,
                "name": "PLS - ENCCO: Patient Care: Modalities of Neonatal Nutrition",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Fluid administration and the selection of parenteral or enteral nutritional support is an important step in the development of the newborn. Parenteral nutrition refers to the intravenous administration of macronutrients and micronutrients. Enteral nutrition provides human milk or formula directly into the gastrointestinal tract, either orally or via tube feeding.\r\n\r\nThis course will discuss these modalities of nutritional support as well as discharge planning to support the caregiver.    \r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Compare modalities of nutritional support utilizing both parenteral and enteral nutrition.&nbsp;</li>\r\n    <li>Analyze evidence-based recommendations and benefits for the use of human milk and/or breastfeeding in premature and high-risk infants.&nbsp;</li>\r\n    <li>Explain components of infant-driven oral feeding readiness assessment and feeding progression.&nbsp;</li>\r\n    <li>Discuss the process of discharge planning from the NICU to home for the high-risk infant.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D59EC0F-E5F9-E611-AF66-005056B104B1",
                        "course_category_name": "Infant Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "42482ECF-2A92-E611-AA6F-005056B10657",
                "course_version": 4,
                "name": "PLS - ENCCO: Infectious Diseases: Neonatal Sepsis",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Sepsis is a syndrome of inflammatory response that results from an infection in the blood. Sepsis begins when chemicals are released into the bloodstream to fight infection.\r\n\r\nIn neonates, infections generally start in the blood, spinal fluid, or urinary tract. Often, the bedside assessment will reveal important details about the newborn\u2019s condition. Recognizing the indicators of neonatal sepsis will assist in prompt treatment and improved outcomes.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Identify risk factors that make the newborn infant more susceptible to infection.&nbsp;</li>\r\n    <li>Distinguish between early- and late-onset sepsis in the neonate.&nbsp;</li>\r\n    <li>Recognize the clinical presentation of sepsis in the neonate, including changes in physical exam and vital signs along with common pathogens, infection sites and laboratory and diagnostic findings.&nbsp;</li>\r\n    <li>Describe the current standards of care and treatment in the management of neonatal sepsis, including antimicrobial stewardship.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CD33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Infection Control",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "AARC; ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "AARC; ACCME; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "CRCE; <em>AMA PRA Category I Credit(s)&trade;</em>;\r\nContact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "280D3D0B-2592-E611-AA6F-005056B10657",
                "course_version": 4,
                "name": "PLS - ENCCO: Patient Care: Maternal Factors Affecting the Newborn",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Conditions affecting the mother can complicate pregnancy and pose a threat to the unborn child. Recognizing and properly managing these conditions will improve mortality and morbidity in the mother and her infant. This course will provide an overview for the health care team of select maternal factors that can affect the newborn and the impact these conditions may have on the infant.\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Recognize risks to the infant related to select maternal pre-existing and gestational conditions as well as identified labor complications.&nbsp;</li>\r\n    <li>Describe the effects at-risk maternal behaviors may have on the newborn.&nbsp;</li>\r\n    <li>Identify interventions to reduce infant risk related to select maternal conditions and at-risk behaviors.&nbsp;</li>\r\n    <li>Detect neonatal signs of complications due to identified maternal conditions or labor complications.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "13BF05A3-D121-EA11-BF7B-005056B14F90",
                "course_version": 3,
                "name": "PLS - ENCCO: Patient Care: Intrauterine Substance Exposure",
                "course_type": 1,
                "author_information": "Tara Sundem,\u00a0RN, MSN, NNP-BC, Amy Holmes, PharmD, BCPPS",
                "description": "Intrauterine substance exposure is when a developing fetus is exposed to substances that cross the placenta during pregnancy. Neonatal abstinence syndrome(NAS)is a condition in the newborn that causes specific symptoms related to the cessation of drug exposure after birth. A subset of NAS, Neonatal opioid withdrawal syndrome(NOWS), is used to describe infants specifically exposed to opioids in utero and is a growing concern as the prevalence has increased. Intrauterine substance exposure can have lasting effects on a newborn\u2019s physical and neurodevelopmental health.\r\n\r\nWhat will you learn in this course?\r\n\r\nThis course introduces:\r\nIncidence of substance abuse during pregnancy\r\nThe effects seen in the newborn\r\nHow to care for the infant experiencing withdrawal\r\nPotential complications and long-term monitoring considerations\r\n\r\nReview details within the body of this course to validate availability of CE credits.",
                "learning_objectives_html": "After completing this learning activity, the participant should be able to:<br />\r\n<ul>\r\n    <li>Discuss the incidence of substance abuse during pregnancy.&nbsp;</li>\r\n    <li>Differentiate between neonatal abstinence syndrome(NAS)and neonatal opioid withdrawal syndrome(NOWS)and describe the effect of substance use on the developing fetus and newborn.&nbsp;</li>\r\n    <li>Outline the clinical presentation of infants affected by intrauterine substance exposure.&nbsp;</li>\r\n    <li>Explain two assessment tools used to screen for, diagnose and quantify severity of signs and symptoms of intrauterine substance exposure.&nbsp;</li>\r\n    <li>Outline non-pharmacologic and pharmacologic interventions, including family engagement strategies, for managing the infant with intrauterine substance exposure.&nbsp;</li>\r\n    <li>Give examples of potential complications and long-term outcomes of infants with intrauterine substance exposure.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4E93A1E9-2688-11DD-914D-0015171C1A75",
                        "course_category_name": "zRemoved-Social Worker",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5302BDF1-21C9-E511-8771-005056B104B1",
                        "course_category_name": "zRemoved-Rehabilitation Counselor",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                        "course_category_name": "Non-Clinical Professional",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B582D9DB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Neonatal Critical Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pharmacist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FD6135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Occupational Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EA6CD84-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "57E706BB-9B69-E311-95D1-001517135213",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Neonatal Critical Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];